// 調整班表
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import '../../../scss/components/pages/edit_staff_shift.scss';
import {GetStoreRole} from'../../../const/constant';
import Calendar from '../../Calendar';
import StaffFilterSelect from '../../StaffFilterSelect';
import { toCalendarEvents, filterEventsByStaff } from '../../util/adjustScheduleEvents';
import API from '../../../middleware/API';
import Swal from 'sweetalert2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
//import moment from 'moment';

import {
  getAdjustmentSchedule,
  getAllStaff,
  InitAPIStatus
} from '../../../store/action';

class AdjustStaffShift extends Component {
  constructor(props) {
    super(props);
    this.state = {
      calendarConfig: {
        defaultView: "month",
        draggable: false,
        isEventClick: true,
        isDayClick: true,
        header: {
          left: 'today prev,next',
          center: 'title',
          right: 'month',

        },
      },
      role: GetStoreRole(localStorage.getItem('current_store_id')),
      selectedDept: '內場',
      selectedDate: null,
      selectedStaffIds: []
    }
    this.calendarRef = React.createRef();
    this.handleDayClick = this.handleDayClick.bind(this);
    this.handleEventClick = this.handleEventClick.bind(this);
    this.handleDeptChange = this.handleDeptChange.bind(this);
    this.handleCheckShiftSchedule = this.handleCheckShiftSchedule.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleCheckFourWeekWorkHours = this.handleCheckFourWeekWorkHours.bind(this);
    this.handleStaffFilterChange = this.handleStaffFilterChange.bind(this);
  }

  componentDidMount() {
    this.props.getAdjustmentSchedule();
    this.props.getAllStaff();
  }

  handleStaffFilterChange(selectedStaffIds) {
    this.setState({ selectedStaffIds });
  }

  handleDayClick(date) {
    if (this.state.role === '2' || this.state.role === '1' || this.state.role === '5' || this.state.role === '3') {
      this.props.history.push(`/adjustStaffShiftDetail/${date.format('YYYY-MM-DD')}`);
    }
    
  }

  handleEventClick(event) {
    if (this.state.role === '2' || this.state.role === '1' || this.state.role === '5' || this.state.role === '3') {
      this.props.history.push(`/adjustStaffShiftDetail/${event.start.format('YYYY-MM-DD')}`);
    }
  }

  handleDeptChange(event) {
    this.setState({ selectedDept: event.target.value });
  }

  handleCheckShiftSchedule() {
    const { selectedDept, calendarConfig } = this.state;
    const currentMonth = this.calendarRef.current.getCurrentMonth();
    console.log(currentMonth);
    const year = new Date().getFullYear();
    const startAt = `${year}-${currentMonth}-01`;
    API.get(`/CheckShiftSchedule?dept=${selectedDept}&startAt=${startAt}`)
      .then(response => {
        const errors = response.errors;
        if (errors && errors.length > 0) {
          Swal.fire({
            title: selectedDept + '排班人員超額',
            html: errors.join('<br>'),
            type: 'error'
          });
        }else{
          Swal.fire({
            title: currentMonth+'月排班人員檢查完成',
            text: selectedDept+'沒有超額人員',
            icon: 'success'
          });
        }
      })
      .catch(error => {
        console.error('There was an error checking the shift schedule!', error);
      });
  }

  handleDateChange(date) {
    console.log(date);
    this.setState({ selectedDate: date });
  }

  handleCheckFourWeekWorkHours() {
    const { selectedDate, selectedDept } = this.state;
    if (selectedDate) {
      console.log(selectedDate);

      const startAt = selectedDate.format('YYYY-MM-DD');
      API.get(`/CheckFourWeekWorkHours?startAt=${startAt}`)
        .then(response => {
          const errors = response.errors;

          if (errors && errors.length > 0) {
            Swal.fire({
              title: selectedDept + '排班人員超時',
              html: errors.join('<br>'),
              type: 'error'
            });
          }
        })
        .catch(error => {
          console.error('There was an error checking the four-week work hours!', error);
        });
    } else {
      Swal.fire({
        title: 'Error',
        text: 'Please select a date.',
        icon: 'error'
      });
    }
  }

  render() {
    let { events, eventStartTime, eventEndTime } = this.props.adjustmentScheduleState;
    // localStorage.setItem("startAt", moment(eventStartTime).format("YYYY-MM-DD").toString())
    // localStorage.setItem("endAt", moment(eventEndTime).format("YYYY-MM-DD").toString())
    events = filterEventsByStaff(toCalendarEvents(events), this.state.selectedStaffIds);
    return (
      <div className="p-editShift">
        <div className="u-block overflow-x">
          <div className="u-title">調整班表
            <a href="https://docs.google.com/presentation/d/1DSrmywetjZQLKrgVTrVbZYc_i4wy6zrUBCtpWtPqQxU/edit#slide=id.p" className="u-how-use" target="_blank">
              <i className="fas fa-question-circle"></i>
            </a>
          </div>
          <div>
            <label htmlFor="deptSelect">部門: </label>
            <select id="deptSelect" value={this.state.selectedDept} onChange={this.handleDeptChange}>
              <option value="內場">內場</option>
              <option value="外場">外場</option>
            </select>
            <button onClick={this.handleCheckShiftSchedule}>檢查班表</button>
          </div>
          <div>
            <label htmlFor="datePicker">選擇日期: </label>
            <DatePicker
              id="datePicker"
              selected={this.state.selectedDate}
              onChange={this.handleDateChange}
              filterDate={date => new Date(date).getDay() === 0}
              placeholderText="選擇起始日期"
            />
            <button onClick={this.handleCheckFourWeekWorkHours}>檢查變形工時</button>
          </div>
          <div className="p-editShift__staffFilter">
            <label htmlFor="staffFilter">篩選員工: </label>
            <StaffFilterSelect
              inputId="staffFilter"
              staffList={this.props.allStaffListInAdjustState}
              value={this.state.selectedStaffIds}
              onChange={this.handleStaffFilterChange}
            />
          </div>
          <div className="p-editShift__calendar">
            <Calendar {...this.state.calendarConfig}
              events={events}
              //startTime={eventStartTime} 
              endTime={eventEndTime}
              ref={this.calendarRef}
              dayClick={this.handleDayClick}
              eventClick={this.handleEventClick}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  SendAPIState: store.SendAPIStatusState,
  adjustmentScheduleState: store.adjustmentScheduleState,
  adjustmentScheduleDetailState: store.adjustmentScheduleDetailState,
  allStaffListInAdjustState: store.allStaffListInAdjustState,
})

export default connect(mapStateToProps,{
  getAdjustmentSchedule,
  getAllStaff,
  InitAPIStatus
})(withRouter(AdjustStaffShift));